import AppState from './app.state';
import AppTypes from './app.types';
import MessagesTypes from 'store/messages/messages.types';
import AnyAction from 'store/anyAction';
import { DEFAULT_LANGUAGE } from 'translations';

const defaultState: AppState = {
    initialised: false,
    lostConnection: false,
    isAgentTyping: false,
    isBotTyping: true,
    ended: null,
    messageInput: '',
    customerName: 'Me',
    sessionID: '',
    contactID: '',
    previousContactID: '',
    instanceID: '',
    logoURL: '',
    agentLogoURL: '',
    customerIconURL: '',
    company: '',
    facia: '',
    botID: '',
    sendMessagePlaceholder: 'Send a message',
    addAttachmentLabel: 'Upload file',
    addEmojiLabel: 'Add emojis',
    theme: {},
    customStyles: '',
    language: DEFAULT_LANGUAGE,
    mode: undefined,
    defaultInputOn: false,
    disableOnCloseConfirmAlert: false,
    endChatConfirm: false,
    showStartNewChatButton: false,
    globalStartChatMessage: null,
    globalPageStatus: null,
    restoreSession: false,
    connectedToAgent: false,
    customerDisconnectFlowStarted: false,
    customerEndedChat: false,
    agentName: undefined,
    connectionDetails: {
        attributes: {},
        contactFlowId: '',
        instanceId: '',
        websocketUrl: '',
    },
    appTextTranslations: null,
    ignoreTransformToLinkTexts: undefined,
    screenReaderLanguage: DEFAULT_LANGUAGE,
    pendingAttachments: []
};

const AppReducer = (state: AppState = defaultState, action: AnyAction): AppState => {
    switch (action.type) {
        case AppTypes.INIT_APP_LOADING:
            return { ...state, initialised: false, error: undefined };
        case AppTypes.INIT_APP:
            return {
                ...state,
                ...action.payload,
                initialised: true,
                ended: false,
                customerDisconnectFlowStarted: false,
                customerEndedChat: false,
            };
        case AppTypes.INIT_APP_ERROR:
            return { ...state, error: action.payload.errorMessage };
        case AppTypes.INIT_DISCONNECT_FLOW:
            return { ...state, ...action.payload, ended: false, customerDisconnectFlowStarted: true };
        case AppTypes.SET_CUSTOMER_ENDED_CHAT:
            return { ...state, customerEndedChat: action.payload };
        case AppTypes.END_CHAT:
            return {
                ...state,
                ended: true,
                endChatConfirm: false,
                connectedToAgent: false,

            };
        case AppTypes.START_NEW_CHAT:
            return {
                ...state,
                ended: false,
                isBotTyping: true,
                isAgentTyping: false,
                translation: state.translation ? {
                    ...state.translation,
                    on: false
                } : undefined
            }
        case AppTypes.SET_END_CHAT_CONFIRM:
            return { ...state, endChatConfirm: action.payload };
        case AppTypes.SET_AGENT_TYPING:
            return {
                ...state,
                isAgentTyping: action.payload.isTyping,
                agentName: action.payload.agentName,
            };
        case AppTypes.SET_BOT_TYPING:
            return { ...state, isBotTyping: action.payload };
        case AppTypes.SET_MODE:
            return { ...state, mode: action.payload };
        case AppTypes.SET_MESSAGE_INPUT:
            return { ...state, messageInput: action.payload };
        case AppTypes.SET_AGENT_CONNECTED:
            return { ...state, connectedToAgent: action.payload };
        case AppTypes.BATCH_UPDATE:
            return { ...state, ...action.payload };
        case AppTypes.SET_LANGUAGE:
            return { ...state, language: action.payload }
        case AppTypes.SET_AUTO_TRANSLATE_CONFIRM:
            return {
                ...state,
                autoTranslateConfirm: action.payload.confirm,
                translation: {
                    detectedLanguages: action.payload.language!,
                    language: undefined,
                    on: false,
                },
            };
        case AppTypes.SET_TRANSLATION_LANGUAGE:
            return {
                ...state,
                translation: {
                    detectedLanguages: [],
                    on: true,
                    ...state.translation,
                    language: action.payload,
                },
            };
        case AppTypes.SET_TRANSLATION_STATUS:
            return {
                ...state,
                translation: state.translation
                    ? {
                          ...state.translation,
                          on: action.payload,
                      }
                    : state.translation,
            };
        case AppTypes.SET_APP_TEXT_TRANSLATIONS:
            return {
                ...state,
                appTextTranslations: action.payload,
            };
        case MessagesTypes.NEW_MESSAGE:
            return { ...state, isAgentTyping: false, isBotTyping: false };
        case MessagesTypes.SEND_FILE:
        case MessagesTypes.SEND_MESSAGE:
            return {
                ...state,
                messageInput: '',
                mode: undefined,
            };
        case AppTypes.SET_GLOBAL_PAGE_STATUS: {
            return {
                ...state,
                globalPageStatus: action.payload,
            };
        }
        case AppTypes.SET_PENDING_ATTACHMENT: {
            return {
                ...state,
                pendingAttachments: [
                    ...state.pendingAttachments,
                    action.payload
                ]
            }
        }
        case MessagesTypes.SET_ATTACHMENT_STATUS: {
            const idToRemove = action.payload.id;

            return {
                ...state,
                pendingAttachments: state.pendingAttachments.filter(attachment => attachment.id !== idToRemove)
            };
        }

        default:
            return state;
    }
}

export default AppReducer;
